// 花嫁の回る連撃 (裾乱れ 0〜6段・三重の返礼) の届きを見せる「前の半円の糸」(2026-10-05)。
//
// ユーザー: 当たりを絵に合わせた結果、裾乱れが絵 (57〜69px) までしか届かなくなった →「B エフェクトで射程を見せる」
//   →「エフェクトを作り始める前に画像でお手本を作ったほうが良いんじゃない？」→ 見本3案から「B 前の半円の糸」。
// 見本 = そざい/fx/bride-flurry-fx-1005/B_front.png・B_behind.png (他作品の調べ = 同じフォルダの references.md・
//   Hollow Knight ホーネットの糸の嵐を「向いている側の半円」に切った物)。
// 約束: 糸は花嫁が向いている側の半円だけ (背中側へ抜ければ当たらない技なので、背中側は空ける)。
//   糸の外側の端 = THREAD_REACH_PX。当たりの前端はそこへ余白 (src/bride_shade_reach.ts REACH_FIT_MARGIN_PX) を足した値。
// 見た目: 1本の線でなく、細い糸が十数本集まって毛羽立った束が3本。根元は淡い紫・先は白く光る。段ごとに上から下・下から上へ交互に薙ぐ。
import { PALETTE } from './balance'

// 糸の束の外側の端 (ボス中心から前へ px)。当たり = これ + 15 (attacks.ts veilFlurry 0〜6段・veilBlinkTriple)。
export const THREAD_REACH_PX = 135
const RY = 82                 // 縦の半径 (頭の少し上〜床すれすれ)
const CY = -22                // 楕円の中心 (FX の起点 = boss.y-50 からの縦ずれ。胸〜腰)
const SWEEP_S = 0.11          // 先頭が半円を走り切る時間
const LIFE_S = 0.34           // 走り切った後に毛羽がほどけて消えるまで
const ARC_FROM = -1.42, ARC_TO = 1.42   // 角度 (0 = 真正面・負 = 上)。±π/2 より少し内側 = 真上・真下で途切れる
const BUNDLES = [             // 3本の束: 大きさの違う三日月を離して並べる (見本 B_front)。lag = 走り出しの遅れ
  // 3本を等間隔・同じ長さに揃えない (「)))」の記号に見えるため)。束ごとに弧の始まり・終わりと傾きを変える。
  { scale: 1.0, tilt: 0.06, lag: 0.0, from: 0.0, to: 1.0 },
  { scale: 0.8, tilt: 0.26, lag: 0.12, from: 0.12, to: 0.86 },
  { scale: 0.63, tilt: -0.18, lag: 0.22, from: 0.05, to: 0.7 },
]
const STRANDS = 13
const SEGS = 18

function rng(seed: number): () => number {
  let s = (seed * 2654435761) >>> 0
  return () => {
    s = (s + 0x6d2b79f5) >>> 0
    let t = s
    t = Math.imul(t ^ (t >>> 15), t | 1)
    t ^= t + Math.imul(t ^ (t >>> 7), t | 61)
    return ((t ^ (t >>> 14)) >>> 0) / 4294967296
  }
}

// x,y = FX の起点 (ボスの位置に付いて動く)、age = 段の始まりからの秒、dir = 向き (+1 右)、hit = 段の番号。
export function drawBrideThreadSweep(
  ctx: CanvasRenderingContext2D, x: number, y: number, age: number, dir: number, hit: number, seed: number,
): void {
  if (age < 0 || age > SWEEP_S + LIFE_S) return
  const down = hit % 2 === 0                       // 偶数段 = 上から下へ、奇数段 = 下から上へ
  const headP = Math.min(1, age / SWEEP_S)          // 先頭の進み (0..1)
  const fade = age <= SWEEP_S ? 1 : Math.max(0, 1 - (age - SWEEP_S) / LIFE_S)
  const fadeE = fade * fade
  const r = rng(seed)
  ctx.save()
  ctx.globalCompositeOperation = 'lighter'
  ctx.translate(x, y + CY)
  ctx.lineCap = 'round'
  for (const b of BUNDLES) {
    const rx = THREAD_REACH_PX * b.scale
    const ry = RY * (0.7 + 0.3 * b.scale)
    const span = ARC_TO - ARC_FROM
    // 束ごとに少し遅れて走る。u (0..1) = 走る向きの進み。走り終えると三日月が丸ごと残る。
    const head = Math.max(0, Math.min(1, headP * (1 + b.lag) - b.lag))
    if (head <= 0) continue
    const angleAt = (u: number) => { const v = b.from + (b.to - b.from) * u; return down ? ARC_FROM + span * v : ARC_TO - span * v }
    // 明るさと太さは弧の真ん中 (真正面・一番遠い所) で最大、上下の端で細く消える。先頭は少しだけ明るい。
    const taper = (u: number) => Math.pow(Math.max(0, Math.cos(angleAt(u))), 0.7)
    const ca = Math.cos(b.tilt), sa = Math.sin(b.tilt)
    const point = (u: number, rOff: number, wob: number): [number, number] => {
      const a = angleAt(u)
      const ex = (rx + rOff) * Math.cos(a), ey = (ry + rOff * 0.6) * Math.sin(a) + wob
      return [dir * (ex * ca - ey * sa * 0.35), ex * sa * 0.35 + ey * ca]
    }
    // 1) 束の芯の淡い紫の滲み (太く薄い・ぼかし)。区間ごとに端を細く。
    ctx.shadowColor = PALETTE.fxViolet
    ctx.shadowBlur = 16
    ctx.strokeStyle = PALETTE.fxViolet
    for (let i = 0; i < SEGS; i++) {
      const u0 = head * (i / SEGS), u1 = head * ((i + 1) / SEGS)
      const t = taper((u0 + u1) / 2)
      ctx.globalAlpha = 0.11 * t * fadeE
      ctx.lineWidth = 4 + 8 * t * b.scale
      const [x0, y0] = point(u0, -3, 0), [x1, y1] = point(u1, -3, 0)
      ctx.beginPath(); ctx.moveTo(x0, y0); ctx.lineTo(x1, y1); ctx.stroke()
    }
    ctx.shadowBlur = 0
    // 2) 細い糸を十数本。半径・うねり・長さ・明るさを1本ずつずらす (毛羽立った束)。
    for (let s = 0; s < STRANDS; s++) {
      const rOff = (r() - 0.5) * 22 * (0.6 + 0.4 * b.scale)
      const wobA = (r() - 0.5) * 9, wobF = 2 + r() * 5, wobPh = r() * 6.28
      const from = r() * 0.35, to = 1 - r() * 0.35   // 糸ごとに始まりと終わりをずらす (端がほつれる)
      const bright = 0.2 + r() * 0.7
      const width = 0.6 + r() * 1.2
      const silver = r() < 0.45
      ctx.strokeStyle = silver ? PALETTE.fxSilver : PALETTE.fxVioletBright
      for (let i = 0; i < SEGS; i++) {
        const u0 = from + (to - from) * (i / SEGS), u1 = from + (to - from) * ((i + 1) / SEGS)
        if (u0 >= head) break
        const uu1 = Math.min(u1, head)
        const t = taper((u0 + uu1) / 2)
        const nearHead = Math.max(0, 1 - (head - uu1) * 6) * (headP < 1 ? 1 : 0)
        ctx.globalAlpha = bright * (0.15 + 0.6 * t + 0.25 * nearHead) * fadeE
        ctx.lineWidth = width * (0.4 + 0.8 * t)
        const [x0, y0] = point(u0, rOff * (1 - 0.3 * fade), wobA * Math.sin(u0 * wobF * 6.28 + wobPh))
        const [x1, y1] = point(uu1, rOff * (1 - 0.3 * fade), wobA * Math.sin(uu1 * wobF * 6.28 + wobPh))
        ctx.beginPath(); ctx.moveTo(x0, y0); ctx.lineTo(x1, y1); ctx.stroke()
      }
    }
    // 3) ちぎれた毛羽: 走った跡から外へ短く跳ねる細かい切れ端。消える間に少し外へ漂う。
    const flecks = 22
    for (let f = 0; f < flecks; f++) {
      const u = head * (0.1 + 0.8 * r())
      const t = taper(u)
      const drift = (1 - fade) * (6 + r() * 14)
      const [px, py] = point(u, 4 + r() * 12 + drift, 0)
      const a = angleAt(u)
      const tx = -Math.sin(a) * dir, ty = Math.cos(a) * 0.6
      const l = 3 + r() * 7
      ctx.strokeStyle = r() < 0.5 ? PALETTE.fxSilver : PALETTE.fxVioletBright
      ctx.globalAlpha = (0.2 + r() * 0.5) * (0.3 + 0.7 * t) * fadeE
      ctx.lineWidth = 0.7 + r() * 0.8
      ctx.beginPath()
      ctx.moveTo(px - tx * l * 0.5, py - ty * l * 0.5)
      ctx.lineTo(px + tx * l * 0.5 + (r() - 0.5) * 3, py + ty * l * 0.5 + (r() - 0.5) * 3)
      ctx.stroke()
    }
  }
  ctx.restore()
}
